import { render, staticRenderFns } from "./prizesForm.vue?vue&type=template&id=42ebca29&scoped=true"
import script from "./prizesForm.vue?vue&type=script&lang=js"
export * from "./prizesForm.vue?vue&type=script&lang=js"
import style0 from "./prizesForm.vue?vue&type=style&index=0&id=42ebca29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ebca29",
  null
  
)

export default component.exports